export const includesAllItems = <T>(a: Array<T>, b: Array<T>): boolean => {
  return (
    a.length === b.length &&
    [...a, ...b].every((item) => typeof item === "string" || typeof item === "number") &&
    a.every((item) => b.includes(item))
  );
};
